module.exports = __webpack_public_path__ + "static/media/name.f4bca90d.svg";